// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7fc04128","239":"cf660e64","455":"fc6f348b"}[chunkId] + ".chunk.js";
};